/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Annual_Promo_HeadlineInputs */

const en_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pay once a year and save ~17%`)
};

const id_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bayar sekali setahun dan hemat ~17%`)
};

const ms_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bayar sekali setahun dan jimat ~17%`)
};

const ca_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paga un cop l'any i estalvia ~17%`)
};

const cs_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plaťte jednou ročně a ušetřete ~17 %`)
};

const da_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betal én gang om året og spar ~17 %`)
};

const de_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einmal jährlich zahlen und rund 17 % sparen`)
};

const et_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maksa kord aastas ja säästa ~17%`)
};

const es_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paga una vez al año y ahorra ~17 %`)
};

const fr_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payez une fois par an et économisez environ 17 %`)
};

const hr_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platite jednom godišnje i uštedite ~17%`)
};

const it_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paga una volta all'anno e risparmia il ~17%`)
};

const lv_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maksājiet reizi gadā un ietaupiet ~17%`)
};

const lt_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mokėkite kartą per metus ir sutaupykite ~17 %`)
};

const hu_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fizess évente egyszer és spórolj ~17%-ot`)
};

const nl_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betaal eens per jaar en bespaar ~17%`)
};

const nb_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betal én gang i året og spar ~17 %`)
};

const pl_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Płać raz w roku o ~17% mniej`)
};

const pt_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pague uma vez por ano e economize 17%`)
};

const ro_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plătește o dată pe an și economisește ~17%`)
};

const sk_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plaťte raz ročne a ušetrite ~17 %`)
};

const sl_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plačajte enkrat letno in prihranite ~17 %`)
};

const fi_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maksa kerran vuodessa ja säästä ~17 %`)
};

const sv_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betala en gång om året och spara ~17 %`)
};

const vi_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanh toán mỗi năm một lần và tiết kiệm ~17%`)
};

const tr_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yılda bir kez ödeyin ve ~%17 tasarruf edin`)
};

const el_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πληρώστε μία φορά το χρόνο και εξοικονομήστε ~17%`)
};

const bg_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платете веднъж годишно и спестете ~17%`)
};

const ru_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платите раз в год и экономьте ~17%`)
};

const sr_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Плаћајте једном годишње и уштедите ~17%`)
};

const uk_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платіть раз на рік і економте ~17%`)
};

const ka_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გადაიხადეთ წელიწადში ერთხელ და დაზოგეთ ~17%`)
};

const hi_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`साल में एक बार भुगतान करें और ~17% बचाएं`)
};

const th_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จ่ายปีละครั้งและประหยัด ~17%`)
};

const ko_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연간 결제로 최대 17% 절약하세요`)
};

const zh_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按年支付可享 2 个月免费订阅`)
};

const zh_tw_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每年支付一次，節省約 17%`)
};

const ja_annual_promo_headline = /** @type {(inputs: Annual_Promo_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年に一度の支払いで約17% お得`)
};

/**
* | output |
* | --- |
* | "Pay once a year and save ~17%" |
*
* @param {Annual_Promo_HeadlineInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const annual_promo_headline = /** @type {((inputs?: Annual_Promo_HeadlineInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Annual_Promo_HeadlineInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_annual_promo_headline(inputs)
	if (locale === "ms") return ms_annual_promo_headline(inputs)
	if (locale === "ca") return ca_annual_promo_headline(inputs)
	if (locale === "cs") return cs_annual_promo_headline(inputs)
	if (locale === "da") return da_annual_promo_headline(inputs)
	if (locale === "de") return de_annual_promo_headline(inputs)
	if (locale === "et") return et_annual_promo_headline(inputs)
	if (locale === "es") return es_annual_promo_headline(inputs)
	if (locale === "fr") return fr_annual_promo_headline(inputs)
	if (locale === "hr") return hr_annual_promo_headline(inputs)
	if (locale === "it") return it_annual_promo_headline(inputs)
	if (locale === "lv") return lv_annual_promo_headline(inputs)
	if (locale === "lt") return lt_annual_promo_headline(inputs)
	if (locale === "hu") return hu_annual_promo_headline(inputs)
	if (locale === "nl") return nl_annual_promo_headline(inputs)
	if (locale === "nb") return nb_annual_promo_headline(inputs)
	if (locale === "pl") return pl_annual_promo_headline(inputs)
	if (locale === "pt") return pt_annual_promo_headline(inputs)
	if (locale === "ro") return ro_annual_promo_headline(inputs)
	if (locale === "sk") return sk_annual_promo_headline(inputs)
	if (locale === "sl") return sl_annual_promo_headline(inputs)
	if (locale === "fi") return fi_annual_promo_headline(inputs)
	if (locale === "sv") return sv_annual_promo_headline(inputs)
	if (locale === "vi") return vi_annual_promo_headline(inputs)
	if (locale === "tr") return tr_annual_promo_headline(inputs)
	if (locale === "el") return el_annual_promo_headline(inputs)
	if (locale === "bg") return bg_annual_promo_headline(inputs)
	if (locale === "ru") return ru_annual_promo_headline(inputs)
	if (locale === "sr") return sr_annual_promo_headline(inputs)
	if (locale === "uk") return uk_annual_promo_headline(inputs)
	if (locale === "ka") return ka_annual_promo_headline(inputs)
	if (locale === "hi") return hi_annual_promo_headline(inputs)
	if (locale === "th") return th_annual_promo_headline(inputs)
	if (locale === "ko") return ko_annual_promo_headline(inputs)
	if (locale === "zh") return zh_annual_promo_headline(inputs)
	if (locale === "zh-tw") return zh_tw_annual_promo_headline(inputs)
	if (locale === "ja") return ja_annual_promo_headline(inputs)
	return en_annual_promo_headline(inputs)
});